<div soho-busyindicator
     [style.height]="'100%'"
     [text]="' '"
     [blockUI]="true"
     [displayDelay]="0"
     [timeToComplete]="this.uiLoadingIndicatorTimeout"
     [transparentOverlay]="true"
>
    @if (isHorizontal) {
        @if (blockGridOptions && blockGridOptions.data && blockGridOptions.data.length > 0) {
          <lm-horizontal-scroller
              #HorizontalScroller
              [scrollAmount]="640"
              [itemCount]="blockGridOptions.data.length"
          >
              @if (blockGridOptions && blockGridOptions.data && blockGridOptions.data.length > 0) {
                <lm-block-grid
                   [showEmptyMessage]="showEmptyMessage"
                   [selectionMode]="selectionMode"
                   [emptyMessageOptions]="emptyMessage"
                   [automationId]="listSpec?.busListSpec?.automationId"
                   [display]="'flex'"
                   [padding]="'5px 0 5px 0'"
                >
                    @for (data of blockGridOptions.data; track data; let i = $index) {
                      <ng-container content>
                          <lm-block-item
                              #LMBlockItem
                              [selected]="data.selected"
                              [blockGridOptions]="blockGridOptions"
                              [data]="data"
                              [populateTooltip]="false"
                              [width]="'320'"
                              [margin]="'0 0 0 15px'"
                              [content]="'sectioned-card'"
                              [isSelectable]="false"
                              [isHorizontal]="true"
                              [automationId]="listSpec?.busListSpec?.automationId"
                              [index]="i"
                              (itemSelected)="onSelected($event)"
                              (itemDoubleClicked)="onDoubleClick($event)"
                          >
                              <ng-container content>
                                  <lm-sectioned-card
                                      [listSpec]="listSpec"
                                      [dataView]="data.dataView"
                                      [sectionedCard]="listSpec.busListSpec.sectionedCard"
                                      [automationId]="listSpec?.busListSpec?.automationId"
                                      [index]="i"
                                      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                                      (uiLinkEvent)="onUILinkEvent($event)">
                                  </lm-sectioned-card>
                              </ng-container>
                          </lm-block-item>
                      </ng-container>
                    }
                </lm-block-grid>
              }
          </lm-horizontal-scroller>
        }
    } @else {
        @if (blockGridOptions && blockGridOptions.data && blockGridOptions.data.length > 0) {
          <lm-block-grid
             [showEmptyMessage]="showEmptyMessage"
             [selectionMode]="selectionMode"
             [emptyMessageOptions]="emptyMessage"
             [automationId]="listSpec?.busListSpec?.automationId"
          >
              @for (data of blockGridOptions.data; track data; let i = $index) {
                <ng-container content>
                    <lm-block-item
                        #LMBlockItem
                        [selected]="data.selected"
                        [blockGridOptions]="blockGridOptions"
                        [data]="data"
                        [populateTooltip]="false"
                        [width]="'320'"
                        [content]="'sectioned-card'"
                        [isSelectable]="selectionMode && selectionMode !== 'single'"
                        [automationId]="listSpec?.busListSpec?.automationId"
                        [index]="i"
                        (contextMenu)="onContextMenu($event)"
                        (itemActivated)="onItemActivated($event)"
                        (itemSelected)="onSelected($event)"
                        (itemUnSelected)="onUnSelected($event)"
                        (itemDoubleClicked)="onDoubleClick($event)"
                    >
                        <ng-container content>
                            <lm-sectioned-card
                                [listSpec]="listSpec"
                                [dataView]="data.dataView"
                                [sectionedCard]="listSpec.busListSpec.sectionedCard"
                                [automationId]="listSpec?.busListSpec?.automationId"
                                [index]="i"
                                (toolbarButtonEvent)="onToolbarButtonEvent($event)"
                                (uiLinkEvent)="onUILinkEvent($event)">
                            </lm-sectioned-card>
                        </ng-container>
                    </lm-block-item>
                </ng-container>
              }
              @if (listSpec && !showAsMingleWidget) {
                <ng-container pager>
                    <lm-list-pager-wrapper
                         id="{{testVersion1 ? listSpec.busListSpec.id + '_pager' : null}}"
                         class="scrollable-flex-footer"
                         [attributes]="pagerIdAttributes"
                         [smallPageSizeSelector]="true"
                         [pageSizeMenuSettings]="{ attachToBody: true }"

                         [enableFirstButton]="hasFirstPage"
                         [enablePreviousButton]="hasPreviousPage"
                         [enableNextButton]="hasNextPage"
                         [enableLastButton]="hasLastPage"

                         [firstPageTooltip]="firstPageButtonTooltip"
                         [previousPageTooltip]="previousPageButtonTooltip"
                         [nextPageTooltip]="nextPageButtonTooltip"
                         [lastPageTooltip]="lastPageButtonTooltip"

                         [showPageSizeSelector]="showPageSizeSelector"
                         [pageSize]="pageSize"
                         [pageSizes]="pageSizes"

                         (firstPage)="onFirstPage()"
                         (previousPage)="onPreviousPage()"
                         (nextPage)="onNextPage()"
                         (lastPage)="onLastPage()"
                         (pageSizeChange)="onPageSizeChange($event)"
                    ></lm-list-pager-wrapper>
                </ng-container>
              }
          </lm-block-grid>
        }
    }
    @if (showEmptyMessage) {
      <div soho-emptymessage
           style="display:initial"
           [emptyMessageOptions]="emptyMessage"
      ></div>
    }
</div>